import React from 'react';
import './ServerCareOffer.css';
import a from './img1.png';
import b from './img2.png';

const fitItems = [
    'עסקים שמפעילים מערכות על גבי שרתי Linux או Windows.',
    'חברות שצריכות ניהול שרתים רציף ולא רק טיפול נקודתי.',
    'ארגונים שצריכים עדכונים, תחזוקה ואבטחה שוטפת.',
    'עסקים שרוצים לשפר גיבוי, שחזור וזמינות.',
    'חברות עם תשתית שרתים קיימת שדורשת סדר וניהול טוב יותר.',
    'ארגונים בינוניים שצריכים מומחיות שרתים בלי להחזיק צוות פנימי מלא.'
];

const problemItems = [
    'השרתים עובדים, אבל אין מספיק ודאות לגבי יציבות או אבטחה.',
    'עדכונים ותחזוקה לא מבוצעים בצורה עקבית.',
    'אין ניטור מספק או טיפול פרואקטיבי.',
    'תקלות חוזרות פוגעות בפעילות.',
    'יש תלות גבוהה מדי באדם אחד שמכיר את השרתים.',
    'לא ברור אם הגיבוי והשחזור באמת מוכנים לרגע האמת.',
    'יש פערים באבטחה או במערכות הפעלה מיושנות.',
    'הסביבה גדלה, אבל ניהול השרתים נשאר מאולתר.'
];

const audienceSignals = [
    'אם אתם צריכים שהשרתים שלכם יהיו מנוהלים בצורה מסודרת ועקבית.',
    'אם יש לכם מערכות פעילות ואתם לא רוצים לגלות בעיות רק אחרי שהשירות נפגע.',
    'אם אתם רוצים להוריד עומס תפעולי מהצוות הפנימי.',
    'אם אתם צריכים גיבוי, תחזוקה, ניטור ושחזור שאפשר באמת לסמוך עליהם.',
    'אם הסביבה שלכם כבר גדלה מעבר לניהול אד-הוק.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הסביבה',
        text: 'ממפים את השרתים, המערכות, הסיכונים והאתגרים התפעוליים.'
    },
    {
        number: '02',
        title: 'מיפוי מצב קיים',
        text: 'בודקים פערי תחזוקה, ניטור, אבטחה, גיבוי ושחזור.'
    },
    {
        number: '03',
        title: 'בניית כיוון ברור',
        text: 'מגדירים ניהול שוטף, ייצוב, תחזוקה ושיפורים נדרשים.'
    },
    {
        number: '04',
        title: 'ניהול והמשך אופטימיזציה',
        text: 'ממשיכים לנטר, לעדכן, לייצב ולשפר את סביבת השרתים לאורך זמן.'
    }
];

const trustPoints = [
    'ניסיון בניהול שרתי Linux ו-Windows.',
    'גישה פרקטית ולא תאורטית בלבד.',
    'חיבור בין תחזוקה, ניטור, אבטחה וגיבוי.',
    'מיקוד ביציבות, זמינות ושיפור תפעולי מתמשך.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const MSPServerSolutionsOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-servercare-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="msp-server-solutions-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">ניהול שרתים לעסקים שצריכים יציבות, אבטחה ושקט תפעולי</h2>
                        <p className="lead offer-description">
                            אנחנו מספקים ניהול שרתים פרואקטיבי, ניטור רציף, תחזוקה שוטפת,
                            עדכוני אבטחה, גיבוי ושחזור כדי שהתשתית שלכם תישאר יציבה, זמינה
                            ומוכנה לעבודה אמיתית.
                        </p>
                        <div className="servercare-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאירו פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center servercare-main-section">
                    <div className="col-md-6">
                        <h3>ניהול שרתים נכון מתחיל הרבה לפני התקלה</h3>
                        <p>
                            המטרה היא לא רק לתקן כשמשהו נופל, אלא למנוע בעיות מוקדם, לשמור על
                            עדכונים שוטפים, לחזק אבטחה ולוודא שהשרתים נשארים יציבים וזמינים.
                        </p>
                        <p>
                            עסקים רבים כבר עברו את שלב הניהול המאולתר. עכשיו הם צריכים תחזוקה
                            מסודרת, נראות טובה יותר ושכבת ניהול עקבית שמפחיתה עומס וסיכון.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img src={a} alt="ניהול שרתים פרואקטיבי וניטור רציף" className="img-fluid" />
                    </div>
                </div>

                <div className="row align-items-center servercare-secondary-section">
                    <div className="col-md-6">
                        <img src={b} alt="תחזוקה, גיבוי ואבטחת שרתים" className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו מספקים ניהול שרתים פרואקטיבי, ניטור 24/7, תחזוקה ועדכוני
                            מערכת, הקשחת אבטחה, גיבוי ושחזור, ותמיכה שוטפת לשרתי Linux ו-Windows.
                        </p>
                        <p>
                            העבודה שלנו מחברת בין שרתים, ענן, אבטחה והמשכיות עסקית כדי ליצור
                            סביבת שרתים מסודרת, יציבה ואמינה יותר לאורך זמן.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">ניהול שרתים פרואקטיבי</div>
                            <div className="signal-item">ניטור 24/7 ותחזוקה שוטפת</div>
                            <div className="signal-item">עדכוני מערכת והקשחת אבטחה</div>
                            <div className="signal-item">גיבוי ושחזור רב-שכבתי</div>
                            <div className="signal-item">תמיכה בשרתי Linux, Windows וענן</div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">מה יוצא לכם מזה</h3>
                            <div className="trust-grid">
                                <div className="trust-item">שרתים יציבים יותר ופחות תקלות והשבתות.</div>
                                <div className="trust-item">עדכונים ותחזוקה מסודרים יותר.</div>
                                <div className="trust-item">יותר ביטחון בגיבוי ובשחזור.</div>
                                <div className="trust-item">פערי אבטחה מצטמצמים.</div>
                                <div className="trust-item">פחות תלות באנשים בודדים.</div>
                                <div className="trust-item">פחות עומס על הצוות הפנימי ויותר שליטה על הסביבה.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם אתם רוצים פחות תקלות ויותר שליטה, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך לייצב, לעדכן ולשפר כדי לבנות סביבת שרתים שאפשר לסמוך עליה.
                            </p>
                            <div className="servercare-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-light btn-lg cta-btn"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg cta-btn"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MSPServerSolutionsOffer;
